export type AutoRefillMainTab = 'schedule_list' | 'add_schedule';
export type AutoRefillAddSubView = 'search' | 'profile';

export interface AutoRefillPharmacyOption {
  id: number;
  label: string;
}

export interface AutoRefillFreqPreset {
  id: string;
  label: string;
  /** Cycle length in days. Null for Custom (use user-entered days). */
  days: number | null;
}

export const AUTO_REFILL_PHARMACY_OPTIONS: AutoRefillPharmacyOption[] = [
  { id: 3, label: 'Advantage Care Pharmacy' },
  { id: 26, label: 'Adelaide Pharmacy' }
];

/** Default pharmacy when opening Auto Refills Report. */
export const AUTO_REFILL_DEFAULT_PHARMACY_ID = 3;

export const AUTO_REFILL_FREQ_PRESETS: AutoRefillFreqPreset[] = [
  { id: 'Q1D', label: 'Q1D (Daily)', days: 1 },
  { id: 'Q7D', label: 'Q7D (Every 7 days)', days: 7 },
  { id: 'Q10D', label: 'Q10D (Every 10 days)', days: 10 },
  { id: 'Q14D', label: 'Q14D (Every 14 days)', days: 14 },
  { id: 'Q28D', label: 'Q28D (Every 28 days)', days: 28 },
  { id: 'Q30D', label: 'Q30D (Every 30 days)', days: 30 },
  { id: 'Q56D', label: 'Q56D (Every 56 days)', days: 56 },
  { id: 'Q1M', label: 'Q1M (Monthly)', days: 30 },
  { id: 'Q6M', label: 'Q6M (Every 6 Months)', days: 180 },
  { id: 'Custom', label: 'Custom', days: null }
];

export const AUTO_REFILL_RX_PAGE_SIZE = 10;
export const AUTO_REFILL_PATIENT_PAGE_SIZE = 20;
